import { createTheme } from "@mui/material";

const Theme = createTheme({
    palette:{
        primary:{
            main:"#F9F9FC"
        },
        secondary:{
            main:"#1F9CB9"
        },
        success:{
            main:"#51CC8A"
        },
        danger:{
            main:"#EF376E"
        },
        warning:{
            main:"#FFCC00"
        },
        info:{
            main:"#747AF2"
        }
        
    },
    typography:{
        h6:{
            color:"#ffffff",
            fontSize:"1rem",
            fontWeight:"400"
            
        }
    }
})

export default Theme;